import { Head, Link } from "@inertiajs/react"

import LandingNavbar from "@/components/landing-navbar"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { signUpPath, pricingPath } from "@/routes"

export default function Welcome() {
  return (
    <>
      <Head title="Welcome">
        <link rel="preconnect" href="https://fonts.bunny.net" />
        <link
          href="https://fonts.bunny.net/css?family=instrument-sans:400,500,600"
          rel="stylesheet"
        />
      </Head>

      <div className="flex min-h-screen flex-col bg-[#FDFDFC] text-[#1b1b18] dark:bg-[#0a0a0a]">
        <LandingNavbar />

        <main className="flex-1">
          {/* Hero Section */}
          <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
            <div className="mx-auto max-w-3xl text-center">
              <h1 className="text-4xl font-bold tracking-tight text-neutral-900 sm:text-6xl dark:text-neutral-100">
                Manage Client Taxes, Reporting, and Performance All in One Place
              </h1>
              <p className="mt-6 text-lg leading-8 text-neutral-600 dark:text-neutral-400">
                Streamline your tax management workflow with powerful reporting tools and real-time
                performance tracking. Built for professionals who need accuracy and efficiency.
              </p>
              <div className="mt-10 flex items-center justify-center gap-x-6">
                <Link href={signUpPath()}>
                  <Button size="lg">Get Started</Button>
                </Link>
                <Link href={pricingPath()}>
                  <Button size="lg" variant="outline" className="text-neutral-900 dark:text-neutral-100">
                    View Pricing
                  </Button>
                </Link>
              </div>
            </div>
          </section>

          {/* Features Section */}
          <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
            <div className="mx-auto max-w-2xl text-center">
              <h2 className="text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl dark:text-neutral-100">
                Everything you need to manage client taxes
              </h2>
              <p className="mt-4 text-lg text-neutral-600 dark:text-neutral-400">
                Powerful features designed to simplify your workflow and improve accuracy.
              </p>
            </div>
            <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
              <Card>
                <CardHeader>
                  <CardTitle>Client Tax Management</CardTitle>
                  <CardDescription>
                    Organize and track tax information for all your clients in one centralized
                    platform. Manage multiple clients efficiently with automated workflows.
                  </CardDescription>
                </CardHeader>
              </Card>
              <Card>
                <CardHeader>
                  <CardTitle>Comprehensive Reporting</CardTitle>
                  <CardDescription>
                    Generate detailed reports with inflation-adjusted calculations and tax basis
                    tracking. Export data in multiple formats for easy sharing and compliance.
                  </CardDescription>
                </CardHeader>
              </Card>
              <Card>
                <CardHeader>
                  <CardTitle>Performance Tracking</CardTitle>
                  <CardDescription>
                    Monitor portfolio performance with real-time updates and historical analysis.
                    Track gains, losses, and tax implications across all client accounts.
                  </CardDescription>
                </CardHeader>
              </Card>
            </div>
          </section>

          {/* CTA Section */}
          <section className="bg-neutral-50 dark:bg-neutral-900">
            <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
              <div className="mx-auto max-w-2xl text-center">
                <h2 className="text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl dark:text-neutral-100">
                  Ready to get started?
                </h2>
                <p className="mt-4 text-lg text-neutral-600 dark:text-neutral-400">
                  Start managing your clients' taxes more efficiently today. Simple pricing, no
                  hidden fees.
                </p>
                <div className="mt-10 flex items-center justify-center gap-x-6">
                  <Link href={signUpPath()}>
                    <Button size="lg">Sign Up Now</Button>
                  </Link>
                  <Link href={pricingPath()}>
                    <Button size="lg" variant="outline" className="text-neutral-900 dark:text-neutral-100">
                      Learn More About Pricing
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </>
  )
}
